<template>
  <rs-side-panel ref="sidePanel">
    <template slot="header">Sakin Ekle</template>
    <template slot="body">
      <v-form ref="form" @submit.prevent="handleFormSubmit">
        <v-row dense>
          <v-col cols="12" sm="6">
            <rs-select-resident
              label="Sakin Seçin"
              :cluster-id="clusterId"
              v-model="formData.resident_id"
              :readonly="disabled"
              :filled="disabled"
              required
            />
          </v-col>
        </v-row>

        <rs-form-buttons
          hide-submit
          :is-loading="isLoading"
          @cancel="hide()"
          @submit="handleFormSubmit"
        />
      </v-form>
    </template>
  </rs-side-panel>
</template>

<script>
import { mapGetters } from "vuex";

import { hasForm } from "@/view/mixins";

export default {
  name: "BatchNotificationResidentForm",
  mixins: [hasForm],
  computed: {
    ...mapGetters(["clusterId"]),
  },
  data() {
    return {
      batchId: null,
      id: null,
      disabled: false,
      totals: {},
    };
  },
  methods: {
    show(batchId) {
      this.batchId = batchId || null;

      this.formData = {
        resident_id: null,
      };

      this.$refs.sidePanel.show();
    },
    hide() {
      this.$refs.sidePanel.hide();
    },
    handleCancelClick() {
      this.hide();
    },
    handleFormSubmit() {
      if (this.isLoading || !this.$refs.form.validate()) {
        this.$toast.error("Lütfen tüm gerekli alanları doldurunuz");
        return false;
      }

      this.isLoading = true;

      const formData = Object.assign({}, this.formData);
      formData.resident_ids = [formData.resident_id];

      this.$api
        .post(`batch-notifications/${this.batchId}/residents`, formData)
        .then(() => {
          this.$toast.success("Eklendi.");
          this.$emit("saved");
          this.hide();
        })
        .catch((error) => {
          this.handleError(error);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>
